<template>
  <v-menu
    ref="menu_date"
    lazy
    :close-on-content-click="false"
    v-model="menu_date"
    transition="scale-transition"
    offset-y
    full-width
    :nudge-right="40"
    min-width="290px"
    :return-value.sync="currentValue"
    :disabled="!edit"
  >
    <v-text-field
      slot="activator"
      :label="label"
      :value="currentValue"
      @input="handleInput($event)"
      :required="required"
      :rules="rules"
      :hint="hint"
      persistent-hint
      :clearable="clearable"
      readonly
    />
    <v-date-picker
      :value="currentValue"
      locale="zh-cn"
      @input="handleInput($event)"
      :type = "type"
      no-title
      scrollable
    >
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="menu_date = false">取消</v-btn>
      <v-btn flat color="primary" @click="$refs.menu_date.save(currentValue)">确定</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
  export default {
    props: [
      'value',
      'label',
      'required',
      'hint',
      'rules',
      'type',
      'clearable',
      'edit'
    ],

    data(){
      return{
        menu_date: false,
        currentValue:this.value
      }
    },

    watch: {
      //读取父节点数据
      'value': 'updateValue'
    },

    methods: {
      //更新vale
      updateValue() {
        this.currentValue = this.value
      },

      handleInput(newvalue) {
        this.$emit('input', newvalue)

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/projLib/util/datePicker.vue